const kitCatalog = [
  {
    id: 'EZ-12564',
    desc: 'Mobile Range Support Unit',
    manu: 'EZ STAK',
    price: '$185,417.00',
  },
  {
    id: 'EZ-10300',
    desc: 'UAS Drone Command Center',
    manu: 'EZ STAK',
    price: '$282,604.00',
  },
  {
    id: 'EZ-11190',
    desc: 'Operations Mobile Command Unit',
    manu: 'EZ STAK',
    price: '$298,958.00',
  },
  {
    id: 'EZ-11192',
    desc: 'Tactical Command Unit',
    manu: 'EZ STAK',
    price: '$310,833.00',
  },
];

const tableBody = document.querySelector('.table__kit tbody');

kitCatalog.forEach(item => {
  const row = document.createElement('tr');
  // Create cells for ID, Description, and Price
  const idCell = document.createElement('td');
  idCell.textContent = item.id;

  const descCell = document.createElement('td');
  descCell.textContent = item.desc;

  const manuCell = document.createElement('td');
  manuCell.textContent = item.manu;

  const priceCell = document.createElement('td');
  priceCell.textContent = item.price;

  // Append the cells to the row
  row.appendChild(idCell);
  row.appendChild(descCell);
  row.appendChild(manuCell);
  row.appendChild(priceCell);

  // Append the row to the table body
  tableBody.appendChild(row);
});
